var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiStarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M6 0L5.65604 0.929524C4.84576 3.11928 3.11928 4.84576 0.929524 5.65604L0 6L0.929523 6.34396C3.11928 7.15424 4.84576 8.88072 5.65604 11.0705L6 12L6.34395 11.0705C7.15424 8.88072 8.88072 7.15424 11.0705 6.34396L12 6L11.0705 5.65605C8.88072 4.84576 7.15424 3.11928 6.34396 0.929524L6 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStarWhite);
export default __webpack_public_path__ + "static/media/ai-star-white.26eca5784212ff28933b6fa0a3ff48f6.svg";
export { ForwardRef as ReactComponent };